import React, { useEffect, useState } from 'react';
import Icon from '../Icon';
import ConfirmButton from '../ConfirmButton';
import localeLookup from '../../config/locale';
import axios from 'axios';
import { axiosRequestGET } from '../../services/serviceConfig';
import Loader from '../Loader';
import cx from 'classnames';

const Document = ({ fileName, url, onDelete, canDelete }) => {
  const [href, setHref] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [didFileLoad, setDidFileLoad] = useState(false);
  const [openFileText, setOpenFileText] = useState(
    localeLookup('translations.Open')
  );

  useEffect(() => {
    // Your code here
    setIsLoading(true);

    axiosRequestGET(url, null, {
      responseType: 'blob',
    })
      .then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data);
        setHref(href);
        setIsLoading(false);
        setDidFileLoad(true);
      })
      .catch((error) => {
        console.error('Error fetching the document:', error);
        setOpenFileText(localeLookup('translations.An error occurred'));
        setIsLoading(false);
      });
  }, []);
  return (
    <div className="document">
      <div className="document__icon-wrapper">
        <Icon className="document__icon" kind="paperclip" />
      </div>
      <div className="document__info">
        <p className="document__info-name">
          <span>{fileName}</span>
        </p>
      </div>
      {canDelete && (
        <ConfirmButton
          onConfirm={onDelete}
          render={(onClick, isActive) => {
            return (
              <button
                onClick={onClick}
                className="ui-btn ui-btn-alert ui-small"
              >
                {localeLookup('translations.Delete')}
              </button>
            );
          }}
        />
      )}
      <a
        href={href}
        download={fileName}
        rel="noopener noreferrer"
        disabled={isLoading || !didFileLoad}
        target="_blank"
        className={cx('ui-btn ui-btn-darkui ui-small document__delete', {
          'document__delete--is-loading': isLoading,
          'document__delete--disabled': !didFileLoad,
        })}
      >
        {isLoading ? (
          <Loader size="small" color={'white'} numberOfDots={3} />
        ) : (
          <span>{openFileText}</span>
        )}
      </a>
    </div>
  );
};

export default Document;
